export default "__VITE_ASSET__e27e9d70__"